import allAssignedIcon from '../../assets/images/all-assigned-students.svg'
import inactiveIcon from '../../assets/images/inactive-icon.svg'
import activeIcon from '../../assets/images/active-icon.svg'
import completeIcon from '../../assets/images/complete-icon.svg'

const sidebarItems = [
  { value: 1, title: 'All assigned students', slot: 'all-assigned-students', icon: allAssignedIcon },
  { value: 2, title: 'Pending students', slot: 'pending-students', icon: inactiveIcon },
  { value: 3, title: 'In Progress students', slot: 'in-progress-students', icon: activeIcon },
  { value: 4, title: 'Completed students', slot: 'completed-students', icon: completeIcon }
]

export default sidebarItems
